import type { CommunityGroup } from "../../services/educationService";
import styles from "./CommunityGroups.module.css";
import { GroupCard } from "./GroupCard";

interface CommunityGroupsProps {
	items: CommunityGroup[];
}

export function CommunityGroups({ items }: CommunityGroupsProps) {
	return (
		<div className={styles.list}>
			{items.map((item) => (
				<GroupCard key={item.id} group={item} />
			))}
		</div>
	);
}
